import React from 'react';
import { ArrowRight, ChevronDown } from 'lucide-react';
import { heroImage } from '../mock';

export default function Hero() {
  return (
    <section style={{ position: 'relative', minHeight: '100vh', background: 'var(--sm-ivory)', overflow: 'hidden', paddingTop: 120 }}>
      <div className="container-x" style={{ position: 'relative', zIndex: 2 }}>
        <div style={{ display: 'grid', gridTemplateColumns: '1.15fr 1fr', gap: 80, alignItems: 'center' }} className="hero-grid">
          <div>
            <div className="fade-up" style={{ display: 'flex', alignItems: 'center', gap: 14, marginBottom: 28 }}>
              <span className="hairline" />
              <span className="overline">Global Distribution · Real Estate Investment</span>
            </div>

            <h1 className="serif fade-up d1" style={{ fontSize: 'clamp(44px, 6vw, 82px)', lineHeight: 1.03, letterSpacing: '-0.01em', margin: 0, color: 'var(--sm-navy)', fontWeight: 600 }}>
              ES Investments<br/>Management<span style={{ color: 'var(--sm-gold)' }}>.</span>
            </h1>

            <div className="fade-up d1" style={{ marginTop: 14, fontSize: 12, letterSpacing: '0.32em', textTransform: 'uppercase', color: 'var(--sm-muted)' }}>
              LLC · New York
            </div>

            <p className="fade-up d2" style={{ marginTop: 32, fontSize: 18, lineHeight: 1.7, color: 'var(--sm-muted)', maxWidth: 560 }}>
              <strong>ES Investments Management LLC</strong> is a New York based global apparel distribution and real estate investment company. ES Investments connects international supply with major North American retail and invests for the long term in real estate.
            </p>

            <div className="fade-up d3" style={{ marginTop: 48, display: 'flex', gap: 16, flexWrap: 'wrap' }}>
              <a href="#business" className="sm-btn">
                Explore the Business <ArrowRight size={16} />
              </a>
              <a href="/about" className="sm-btn sm-btn-outline">About the Company</a>
            </div>

            <div className="fade-up d4" style={{ marginTop: 88, display: 'flex', gap: 56, flexWrap: 'wrap' }}>
              <div>
                <div className="serif" style={{ fontSize: 40, color: 'var(--sm-navy)' }}>20<span style={{ color: 'var(--sm-gold)' }}>+</span></div>
                <div style={{ fontSize: 11, letterSpacing: '0.24em', textTransform: 'uppercase', color: 'var(--sm-muted)', marginTop: 4 }}>Years of Experience</div>
              </div>
              <div>
                <div className="serif" style={{ fontSize: 40, color: 'var(--sm-navy)' }}>Global</div>
                <div style={{ fontSize: 11, letterSpacing: '0.24em', textTransform: 'uppercase', color: 'var(--sm-muted)', marginTop: 4 }}>Sourcing Network</div>
              </div>
              <div>
                <div className="serif" style={{ fontSize: 40, color: 'var(--sm-navy)' }}>NYC</div>
                <div style={{ fontSize: 11, letterSpacing: '0.24em', textTransform: 'uppercase', color: 'var(--sm-muted)', marginTop: 4 }}>Headquarters</div>
              </div>
            </div>
          </div>

          <div className="fade-up d2" style={{ position: 'relative' }}>
            <div style={{ position: 'relative', aspectRatio: '4/5', overflow: 'hidden', boxShadow: '0 30px 80px -30px rgba(11,30,63,0.35)' }}>
              <img src={heroImage} alt="ES Investments Management LLC headquarters — global apparel distribution and real estate investment in New York" style={{ width: '100%', height: '100%', objectFit: 'cover', filter: 'contrast(1.02)' }} />
              <div style={{ position: 'absolute', inset: 0, background: 'linear-gradient(180deg, rgba(11,30,63,0.15) 0%, rgba(11,30,63,0.35) 100%)' }} />
            </div>
            <div style={{ position: 'absolute', bottom: -30, left: -30, background: 'var(--sm-navy)', color: 'var(--sm-ivory)', padding: '22px 26px', maxWidth: 280 }}>
              <div style={{ fontSize: 11, letterSpacing: '0.28em', textTransform: 'uppercase', color: 'var(--sm-gold-soft)', marginBottom: 8 }}>Operating Network</div>
              <div className="serif" style={{ fontSize: 18, lineHeight: 1.35 }}>New York · California · Florida</div>
            </div>
          </div>
        </div>
      </div>

      <div style={{ position: 'absolute', bottom: 32, left: '50%', transform: 'translateX(-50%)', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 10, color: 'var(--sm-muted)' }}>
        <div style={{ fontSize: 10, letterSpacing: '0.32em', textTransform: 'uppercase' }}>Scroll</div>
        <ChevronDown size={18} style={{ animation: 'floaty 2s ease-in-out infinite' }} />
      </div>

      <style>{`
        @keyframes floaty { 0%,100% { transform: translateY(0);} 50% { transform: translateY(8px);} }
        @media (max-width: 900px) {
          .hero-grid { grid-template-columns: 1fr !important; gap: 60px !important; }
        }
      `}</style>
    </section>
  );
}
